<template>
  <div class="home">
    <van-sticky>
      <div class="home_top">
        <van-icon name="comment-o" color="#fff" size="23" dot />
        <van-search
          placeholder="请输入标题搜索"
          disabled
          @click="toSearch(1)"
        />
        <div class="top_right" @click="toLocation()">
          {{ locationValue }}
          <van-icon class="m-l10" name="arrow-down" color="#fff" />
        </div>
      </div>
    </van-sticky>

    <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <van-image
          @click="seeShare(image.itemLinkUrl)"
          width="100%"
          :src="image.itemUrl"
          height="200"
          fit="cover"
        />
      </van-swipe-item>
    </van-swipe>

    <!-- 菜单选项 -->
    <div class="home_menu">
      <div class="menu_left" @click="toSearch(0)">
        <van-image width="40" src="/static/images/index_01.png" />
        <span>场地中心</span>
        <div>在这里快速找到你想要的场地资源</div>
      </div>
      <div class="menu_right">
        <div class="right" @click="toApplicationForSite">
          <van-image width="35" height="35" src="/static/images/index_02.png" />
          <div class="flex_column">
            <span class="m-t10">我是场地方</span>
            <div>你有场地立即发布出来共享平台客源</div>
          </div>
        </div>
        <div class="right m-t10" @click="toLookingSite">
          <van-image width="35" height="35" src="/static/images/index_03.png" />
          <div class="flex_column">
            <span class="m-t10">帮我找场地</span>
            <div>立即填写你的需求我们来给你匹配</div>
          </div>
        </div>
      </div>
    </div>

    <BuildingList
      :offsetTop="50"
      :currentAddress="locationValue"
      :searchValue="searchValue"
    ></BuildingList>
    <van-button round color="#3894FF" size="normal" @click="toSearch(0)"
      >查看更多</van-button
    >
  </div>
</template>
<script>
import {
  Button,
  Swipe,
  SwipeItem,
  Icon,
  Search,
  Image,
  DropdownMenu,
  DropdownItem,
  Tag,
  Sticky,
  Cell,
  Cascader,
} from "vant";

import BuildingList from "./components/BuildingList";
import common from "@/utils/common";
import storage from "@/utils/storage";

export default {
  components: {
    [Button.name]: Button,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Icon.name]: Icon,
    [Search.name]: Search,
    [Image.name]: Image,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Tag.name]: Tag,
    [Sticky.name]: Sticky,
    [Cell.name]: Cell,
    [Cascader.name]: Cascader,
    BuildingList,
  },
  data() {
    return {
      searchValue: "",
      locationValue: "中山市",
      images: [],
      //必须配置项，从接口获取
      appId: "",
      timestamp: "",
      noncstr: "",
      signatureInfo: "",
      // 自配项
      imgurl: "", //分享图片（如分享出来链接上显示的小图标）
      url: "", //分享地址（如分享出来一个链接，点链接要跳的页面地址）
      title: "",
      desc: "",
    };
  },

  //初始化加载
  created() {
    //如果有缓存地址则直接赋值当前地址
    var address = storage.getCurrentLocation();
    if (address != false) {
      console.log("12123");
      this.locationValue = address.selectAddress;
    } else {
      console.log("489798");
      //获取当前定位地址
      this.getCurrentLocation();
    }
    //轮播图列表
    this.banner();
    this.shareInfo();
  }, 

  methods: {

    seeShare(url) {
      window.location.href = url;
    },

    //申请成为场地方（判断申请场地状态）
    toApplicationForSite() {
      var that = this;
      that.$api
        .siteSupplierApplyDetailAPI("")
        .then(function (res) {
          var applyStatus = Number(res.data.data.applyStatus);
          if (res.data.code === 200) {
            // 申请状态，1-待审核/2-已完成/3-已拒绝
            if (applyStatus === 1) {
              //跳转提交申请场地成功界面
              that.$router.push({ path: "/personal/materialProgress" });
            } else if (applyStatus === 2) {
              //跳转场地方界面
              that.$router.push({ name: "Place" });
            } else {
              //跳转申请场地界面
              that.$router.push({ path: "/personal/applicationForSite" });
            }
          }
        })
        .catch(function (err) {
          console.log("error", err);
          that.$router.push({ path: "/personal/applicationForSite" });
        });
    },

    //轮播图列表
    banner() {
      var that = this;
      that.$api
        .bannerAPI("")
        .then(function (res) {
          if (res.data.code === 200) {
            that.images = res.data.data.bannerList;
          }
        })
        .catch(function (err) {
          console.log("error", err);
        });
    },

    //获取当前定位地址
    getCurrentLocation() {
      var that = this;
      //定义回调函数
      window.initBaiduMapScript = () => {
        that.BMap = window.BMap;
        var geolocation = new that.BMap.Geolocation();
        geolocation.getCurrentPosition(
          function (r) {
            if (this.getStatus() == 0) {
              r.selectAddress = r.address.city;
              //成功获取位置信息
              that.locationValue = r.address.city ? r.address.city : "中山市";
              //设置当前地址信息
              storage.setCurrentLocation(r);
            }
          },
          {
            enableHighAccuracy: true,
          }
        );
      };
      //调用脚本获取位置信息
      common.loadBMap("initBaiduMapScript");
    },

    //跳转定位界面
    toLocation() {
      this.$router.push({ path: "/home/location" });
    },

    //跳转搜索界面
    toSearch(status) {
      this.$router.push({
        path: "/home/search",
        query: { searchShow: status },
      });
    },

    //跳转帮我找场地
    toLookingSite() {
      this.$router.push({ path: "/home/lookingSite" });
    },

    shareInfo() {
      let that = this;
      that.$api
        .shareInfoAPI({ url: location.href.split("#")[0] })
        .then((res) => {
          if (res.data.code === 200) {
            //这些配置参数必填项，后面去调微信的pai是需要传的。
            that.appId = res.data.data.appid;
            that.timestamp = res.data.data.timeStamp;
            that.noncstr = res.data.data.nonceStr;
            that.signatureInfo = res.data.data.signature;
            that.shareFriend()
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    shareFriend() {
      let that = this;
      //当点击分享好友按钮时
      //怎么取图片的地址取决于你放图片的路径，你也可以用线上图片，也可以放在你们的服务器上。
      /*that.imgurl =
        that.detailData.videoList.length > 0 ?
          that.detailData.videoList[0].thumbnailUrl :
          that.detailData.coverImageUrl;*/
      that.url = window.location.href;
      that.title = '托管云';
      that.desc = '专业专注辅助创业，地址托管专家！在线完成地址租赁工作';
      that.sharewxinit()
    },

    sharewxinit() {
      let that = this;

      //开始注入配置项
      wx.config({
        debug: false, //是否打开debug调试模式。
        appId: that.appId, //必填，公众号唯一标识
        timestamp: that.timestamp, //必填，生成签名的时间戳
        nonceStr: that.noncstr, //必填，生成签名的随机串
        signature: that.signatureInfo, //必填，生成的签名
        jsApiList: ['checkJsApi',
          'updateTimelineShareData',
          'updateAppMessageShareData',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
        ], //必填，允许分享好友，分享朋友圈
      });

      wx.ready(function () {
        // //分享到朋友圈的
        wx.updateTimelineShareData({
          title: that.title, // 分享标题
          link: that.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.imgurl, // 分享图标
          success: function () {
            console.log("已分享朋友圈成功");
          },
          fail: function () {
            console.log("分享朋友圈失败");
          },
        });

        // //分享给朋友的
        wx.updateAppMessageShareData({
          title: that.title, // 分享标题
          desc: that.desc, // 分享描述
          link: that.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.imgurl, // 分享图标
          type: '',
          dataUrl: '',
          success: function (res) {
            console.log("分享好友成功" + JSON.stringify(res));
          },
          fail: function (res) {
            console.log("分享好友失败" + JSON.stringify(res));
          },
        });

        wx.onMenuShareTimeline({
          //配置去分享朋友圈的选项
          title: that.title, //分享标题
          link: that.url, //分享链接
          imgUrl: that.imgurl, //分享图标
          success: function (res) {
            //分享成功
            that.$Toast("已分享朋友圈成功");
            //如分享成功后想做一些其他的业务处理，可以在这里做
          },
          cancel: function () {
            //that.alert="失败弹框话术等等(注意 这里拿不到this实例的)"
            that.$Toast("已分享失败");
          },
        });

        wx.onMenuShareAppMessage({
          //配置去分享好友的选项
          title: that.title,
          link: that.url,
          desc: that.desc,
          imgUrl: that.imgurl,
          success: function (res) {
            that.$Toast("分享好友成功");
          },
          cancel: function (res) {
            that.$Toast("分享失败");
          },
        });
      });
    },
  },
};
</script>

<style lang="less">
.home {
  display: flex;
  justify-content: center;
  flex-direction: column;

  .van-button {
    width: 150px;
    margin: 10px auto;
  }

  .list {
    .van-dropdown-menu__title {
      font-size: 14px;
    }
    .van-dropdown-menu__bar {
      box-shadow: unset;
    }
  }

  .home_top {
    padding: 0px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #3aa9ff;
    height: 50px;

    .van-search {
      padding: 0px;
      border-radius: 4px;
      overflow: hidden;
    }

    .top_right {
      display: flex;
      align-items: center;
      font-size: 15px;
      color: #fff;
    }
  }

  // 菜单选项
  .home_menu {
    padding: 10px;
    padding-top: 5px;
    display: flex;
    justify-content: space-between;

    .menu_left {
      width: 30%;
      background: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 10px;
      padding: 0px 15px;
      font-size: 18px;
      font-weight: bold;
      justify-content: center;
      box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);

      div {
        font-size: 13px;
        font-weight: normal;
        padding: 10px 0px;
      }
    }

    .menu_right {
      width: 58%;
      display: flex;
      flex-direction: column;

      .right {
        display: flex;
        background: #fff;
        border-radius: 10px;
        padding: 0px 15px;
        box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
        justify-content: space-between;
        align-items: center;

        .flex_column {
          width: 75%;
          font-size: 18px;
          font-weight: bold;
          div {
            font-size: 13px;
            font-weight: normal;
            padding: 10px 0px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/home/index.vue